/* HILO — image slider on product cards.

   One delegated listener for the whole page rather than one per card. A
   collection page can hold 50+ cards, and this also means cards added AFTER
   load work automatically — infinite scroll, quick filters, and the wedding
   guide swapping its grid all get sliders with no extra wiring.
*/
(function(){
  if (window.__hiloCardSlider) return;
  window.__hiloCardSlider = true;

  var SEL = '.hilo-cs';

  function slidesOf(cs){ return cs.querySelectorAll('.hilo-cs__slide'); }
  function dotsOf(cs){ return cs.querySelectorAll('.hilo-cs__dot'); }

  function current(cs){ return parseInt(cs.getAttribute('data-i') || '0', 10); }

  function show(cs, i){
    var slides = slidesOf(cs);
    var dots   = dotsOf(cs);
    var total  = slides.length + 1;          /* +1 = the card's own image */

    if (i < 0) i = total - 1;
    if (i >= total) i = 0;
    cs.setAttribute('data-i', i);

    /* Index 0 means: hide every overlay slide and let the original image show. */
    for (var s = 0; s < slides.length; s++){
      slides[s].classList.toggle('is-on', (s + 1) === i);
    }
    for (var d = 0; d < dots.length; d++){
      dots[d].classList.toggle('is-on', d === i);
    }
  }

  function nearest(el){
    return el && el.closest ? el.closest(SEL) : null;
  }

  document.addEventListener('click', function(e){
    var dot = e.target.closest ? e.target.closest('.hilo-cs__dot') : null;
    if (dot){
      var cs1 = nearest(dot);
      if (!cs1) return;
      e.preventDefault(); e.stopPropagation();
      show(cs1, parseInt(dot.getAttribute('data-idx'), 10));
      return;
    }

    var arrow = e.target.closest ? e.target.closest('.hilo-cs__arrow') : null;
    if (arrow){
      var cs2 = nearest(arrow);
      if (!cs2) return;
      e.preventDefault(); e.stopPropagation();
      var step = arrow.classList.contains('hilo-cs__arrow--next') ? 1 : -1;
      show(cs2, current(cs2) + step);
    }
  }, true);   /* capture, so the card's own click handler never fires first */

  /* ---- swipe ---- */
  var startX = 0, startY = 0, tracking = null;

  document.addEventListener('touchstart', function(e){
    var mask = e.target.closest ? e.target.closest('.grid-product__image-mask') : null;
    var cs = mask ? mask.querySelector(SEL) : null;
    if (!cs) { tracking = null; return; }
    tracking = cs;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, {passive:true});

  document.addEventListener('touchend', function(e){
    if (!tracking) return;
    var t  = e.changedTouches[0];
    var dx = t.clientX - startX;
    var dy = t.clientY - startY;

    /* Horizontal, deliberate, and not a vertical scroll that drifted. */
    if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.5){
      show(tracking, current(tracking) + (dx < 0 ? 1 : -1));
    }
    tracking = null;
  }, {passive:true});

  /* Keyboard, for anyone tabbing through the card. */
  document.addEventListener('keydown', function(e){
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var cs = nearest(document.activeElement);
    if (!cs) return;
    e.preventDefault();
    show(cs, current(cs) + (e.key === 'ArrowRight' ? 1 : -1));
  });
})();